import { render } from "./MbIndexNameDisp.vue?vue&type=template&id=a70bc588&scoped=true"
import script from "./MbIndexNameDisp.vue?vue&type=script&lang=js"
export * from "./MbIndexNameDisp.vue?vue&type=script&lang=js"

import "./MbIndexNameDisp.vue?vue&type=style&index=0&id=a70bc588&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a70bc588"

export default script